import { useSyncExternalStore } from 'react'
import { sessionStore } from './sessionStore'

/** True while a session (access or refresh token) exists. */
export function useHasSession(): boolean {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.hasSession)
}
